import { Typography, Stack, StackProps } from '@mui/material';
import React from 'react';

import HauserLogo from '@/assets/images/hauser-logo.svg?react';
import { useTranslationPrefix } from '@/translations/i18n';

export interface HauserLogoWithTagLineProps {
  containerProps?: StackProps;
}

export const HauserLogoWithTagLine: React.FC<HauserLogoWithTagLineProps> = ({ containerProps }) => {
  const t = useTranslationPrefix('common');

  return (
    <Stack
      spacing={5}
      alignItems="center"
      {...containerProps}
      sx={{
        ...containerProps?.sx,
      }}>
      <HauserLogo width={253} height={50} />

      <Stack direction="row">
        <Typography variant="body1" color="text.secondary">
          {t('tagline.0')}
          <Typography variant="body1" component="span" fontWeight="600">
            {t('tagline.1')}
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  );
};
